import * as commander from "commander";


commander
    .command("login", "Generate a new authentication token to be used by this cli, and store it locally.");

commander.parse(process.argv);
if (!commander.args.length) commander.help();